import { createAsyncThunk } from '@reduxjs/toolkit';
import { stepService } from '../../services';

const findAllStepWithForm = () => createAsyncThunk('step/findAllWithForm', async (optionId: string) => stepService.findAllWithForm(optionId));

export default {
  findAllStepWithForm: findAllStepWithForm(),
};
